<template>
  <aside class="sidebar-step">
    <nav
      class="nav-step"
      v-if="showSteps"
    >
      <ul class="step-list scrollbar">
        <li
          v-for="(item, itemIndex) in menuItems"
          :key="itemIndex"
          :class="itemClass(item)"
        >
          <button
            class="step-item"
            @click="() => handleStepItemClick(item)"
          >
            {{ itemIndex + 1 }}
            <span>{{ $t(item.label) }}</span>
            <i class="check-icon check-icon--small"></i>
          </button>
          <ul class="sub-step" v-if="item.children && item.children.length > 0">
            <li
              v-for="(childItem, childItemIndex) in item.children"
              :key="childItem.step"
              :class="itemClass(childItem)"
            >
              <button
                type="button"
                class="step-item"
                @click="() => handleStepItemClick(childItem)"
              >
                {{ itemIndex + 1}}.{{ childItemIndex + 1 }}
                <span>{{ $t(childItem.label) }}</span>
                <i class="check-icon check-icon--small"></i>
              </button>
            </li>
          </ul>
        </li>
      </ul>
    </nav>
    <div class="sidebar-step__contact">
        <figure>
          <img
            v-if="companyInfo.logo"
            alt="Logo Internorm"
            :src="companyInfo.logo"
          >
        </figure>
        <a :href="`tel:${companyInfo.phone }`">
          <template v-if="companyInfo.phone">
            {{ companyInfo.phone }}
          </template>
        </a>

        <a :href="`mail:${companyInfo.email }`" >{{ companyInfo.email }}</a>
        <address class="copyrights">
            <span>{{ companyInfo.name }}</span>
            <span>{{ companyInfo.address }}</span>
            <span>{{ companyInfo.zip }} {{ companyInfo.city }}</span>
        </address>
    </div>
    
  </aside>
</template>

<script>
  import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';

  export default {
    name: 'AppSidebar',
    methods: {
      ...mapActions({
        goToStep: 'configurator/goToStep',
      }),
      ...mapMutations({
        setCurrentStepId: 'configurator/setCurrentStepId',
      }),
      itemClass(item) {
        return {
          active: item.active,
          current: item.current,
        };
      },
      handleStepItemClick(item) {
        if (item.stepId) {
          this.goToStep({ stepId: item.stepId });
        }
      },
    },
    computed: {
      ...mapGetters({
        completed: 'configurator/completed',
        editing: 'configurator/editing',
        menuItems: 'configurator/getMenuItems',
      }),
      ...mapState({
        configuratorOpened: state => state.configurator.opened,
        companyInfo: state => state.companyInfo,
      }),
      showSteps() {
        const { configuratorOpened, menuItems, completed } = this;

        if (completed) {
          return false;
        }

        return configuratorOpened && (menuItems && menuItems.length > 0);
      },
    },
  };
</script>
